import React from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import PageBuilder from '../../containers/PageBuilder/PageBuilder';
import background from '../../assets/Group 483.png';
import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import css from './LandingPage.module.css';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  SetInterviewBar,
  Topbar,
  TopbarDesktop,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import SectionContainer from '../PageBuilder/SectionBuilder/SectionContainer';
import { FormattedMessage, injectIntl } from 'react-intl';
import HeroContainer from '../../components/HeroContainer/HeroContainer';
import BusinessWeServe from '../../components/BusinessWeServe/BusinessWeServe';
import BusinessComp from '../../components/BusinessComp/BusinessComp';
import BusinessOwner from '../../components/BusinessOwner/BusinessOwner';
import BusinessWorker from '../../components/BusinessWorker/BusinessWorker';
import WhySosOwner from '../../components/WhySos_Owner/WhySosOwner';
import HowDoesItWork from '../../components/HowDoesItWork/HowDoesItWork';
import WhySosStaff from '../../components/WhySosStaff_Second/WhySosStaff';
import HowDoesItWork2 from '../../components/HowDoesItWork/HowDoesItWork2';
import HowDoISignUp from '../../components/HowDoISignUp/HowDoISignUp';
import AboutSos from '../AboutSos/AboutSos';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import config from '../../config';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router-dom';

export const LandingPageComponent = props => {
  const {
    scrollingDisabled,
    intl,
    onManageDisableScrolling,
    currentUser,
    userNativeLang,
    isAuthenticated,
    history,
  } = props;

  // console.log(currentUser, isAuthenticated, 123);
  const isProvider = currentUser && currentUser?.attributes?.profile?.publicData?.isProvider;

  const isSuperAdmin = currentUser && currentUser?.attributes?.profile?.publicData?.isSuperAdmin;

  //superadmin default landing page
  if (isAuthenticated && currentUser && isSuperAdmin) {
    history.push(createResourceLocatorString('AdminStaffPage', routeConfiguration(), {}, {}));
    return <></>;
  }
  //provider default landing page
  else if (isAuthenticated && currentUser && isProvider) {
    history.push(
      createResourceLocatorString('BusinessDashboardStaffPage', routeConfiguration(), {}, {})
    );
    return <></>;
  }
  //worker deafult landing page
  else if (isAuthenticated && currentUser && !isProvider) {
    history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}));
    return <></>;
  }

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          {/* <TopbarContainer className={topbarClasses} /> */}
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.layoutWrapperMain}>
          {/* <div className={css.root}>
              {showEmailVerification ? emailVerificationContent : formContent}
            </div>
            <Modal
              id="AuthenticationPage.tos"
              isOpen={this.state.tosModalOpen}
              onClose={() => this.setState({ tosModalOpen: false })}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.termsWrapper}>
                <TermsOfServiceContent
                  inProgress={tosFetchInProgress}
                  error={tosFetchError}
                  data={tosAssetsData?.[camelize(TOS_ASSET_NAME)]?.data}
                />
              </div>
            </Modal> */}

          <HeroContainer />
          <div className={css.bws}>
            <BusinessWeServe onManageDisableScrolling={onManageDisableScrolling} />
            <BusinessComp />
          </div>

          {/* <BusinessOwner /> */}
          {/* <WhySosOwner /> */}
          {/* <HowDoesItWork /> */}
          {/* <BusinessWorker /> */}
          {/* <WhySosStaff /> */}
          {/* <HowDoesItWork2 /> */}
          {/* <HowDoISignUp /> */}
          {/* <AboutSos /> */}
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>

    //    <PageBuilder
    //   pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
    //   inProgress={inProgress}
    //   error={error}
    //   fallbackPage={<FallbackPage error={error} />}
    // />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUser } = state.user;
  const { userNativeLang } = state.UI;
  const { isAuthenticated } = state.Auth;

  // console.log(2, isAuthenticated);
  return {
    pageAssetsData,
    inProgress,
    error,
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    isAuthenticated,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});
// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  injectIntl
)(LandingPageComponent);

export default LandingPage;
